import { render, staticRenderFns } from "./SheriffViewElevador.vue?vue&type=template&id=25ab0856&scoped=true&"
import script from "./SheriffViewElevador.vue?vue&type=script&lang=js&"
export * from "./SheriffViewElevador.vue?vue&type=script&lang=js&"
import style0 from "./SheriffViewElevador.vue?vue&type=style&index=0&id=25ab0856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab0856",
  null
  
)

component.options.__file = "SheriffViewElevador.vue"
export default component.exports